import { createStore } from 'zustand';

import { Place } from '@/types/google-maps.types';
import { LoginOriginEnum } from '@/types/enums/analytics/login/login-analytics.enum';
import type { SearchModalOpenContext } from '@/store/search/search.store';

export type ModalsOpeningState = {
  locationSelectionModalIsOpen: boolean;
  deniedGeolocation: boolean;
  signInModalIsOpen: boolean;
  signInModalInitialStep?: string;
  signInModalOrigin?: LoginOriginEnum;
  loginCallback?: () => void;
  dismissCallback?: () => void;
  locationCallback?: (userLocation?: Partial<Place>) => void;
  pendingSearchTerm?: string;
  pendingSearchContext?: SearchModalOpenContext;
  shouldOpenSearchModal?: boolean;
  shouldScrollToBranchesListOnNavigate?: boolean;
};

export const modalsOpeningStore = createStore<ModalsOpeningState>(() => {
  return {
    locationSelectionModalIsOpen: false,
    deniedGeolocation: false,
    signInModalIsOpen: false,
  };
});

export interface SetOpenLocationSelectionModalOptions {
  locationCallback?: (userLocation?: Partial<Place>) => void;
  pendingSearchTerm?: string;
  pendingSearchContext?: SearchModalOpenContext;
  shouldOpenSearchModal?: boolean;
  shouldScrollToBranchesListOnNavigate?: boolean;
}

export const setOpenLocationSelectionModal = (
  isOpen: boolean,
  options?: SetOpenLocationSelectionModalOptions,
) => {
  modalsOpeningStore.setState((prev) => ({
    locationSelectionModalIsOpen: isOpen,
    locationCallback: isOpen ? options?.locationCallback : undefined,
    pendingSearchTerm: isOpen ? options?.pendingSearchTerm : undefined,
    pendingSearchContext: isOpen ? options?.pendingSearchContext : undefined,
    shouldOpenSearchModal: isOpen ? options?.shouldOpenSearchModal : undefined,
    shouldScrollToBranchesListOnNavigate: isOpen
      ? options?.shouldScrollToBranchesListOnNavigate
      : prev.shouldScrollToBranchesListOnNavigate,
  }));
};

export const setDeniedGeolocation = (denied: boolean) => {
  modalsOpeningStore.setState({ deniedGeolocation: denied });
};

export interface SetOpenSignInModalOptions {
  loginCallback?: () => void;
  dismissCallback?: () => void;
  initialStep?: string;
  origin?: LoginOriginEnum;
}

export const setOpenSignInModal = (isOpen: boolean, options?: SetOpenSignInModalOptions) => {
  modalsOpeningStore.setState({
    signInModalIsOpen: isOpen,
    loginCallback: isOpen ? options?.loginCallback : undefined,
    dismissCallback: isOpen ? options?.dismissCallback : undefined,
    signInModalInitialStep: isOpen ? options?.initialStep : undefined,
    signInModalOrigin: isOpen ? options?.origin : undefined,
  });
};

export const dismissSignInModal = () => {
  const { dismissCallback } = modalsOpeningStore.getState();

  setOpenSignInModal(false);
  dismissCallback?.();
};
